module.exports = __webpack_public_path__ + "img/1_1-stazione_carburante-0.f8f18193.png";